import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=72541eff&scoped=true&"
import script from "./Roles.vue?vue&type=script&lang=js&"
export * from "./Roles.vue?vue&type=script&lang=js&"
import style0 from "./Roles.vue?vue&type=style&index=0&id=72541eff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72541eff",
  null
  
)

export default component.exports